import { callWithRetry, getExponentialBackoff } from '@air/call-with-retry';
import { FAILED_TO_FETCH, matchesAirror } from '@air/errors';

const MAX_RETRIES = 3;

export const callRequestWithRetry = <T>(action: () => Promise<T>): Promise<T> =>
  callWithRetry({
    action,
    getRetryDelay: (attempt) =>
      getExponentialBackoff({
        attempt,
        factor: 2,
        initialDelay: 200,
        maxDelay: 800,
      }),
    shouldRetry: (retries, error) => retries < MAX_RETRIES && matchesAirror(error, FAILED_TO_FETCH),
  });
